import Grid from '@mui/material/Grid2';
import { Box, Stack, Typography } from "@mui/material";
import swift from '../../assets/why-choose/swift.png';
import countries from '../../assets/why-choose/countries.png';
import alternative from '../../assets/why-choose/alternative.png';
import currencies from '../../assets/why-choose/currencies.png';

const WhyChoose: React.FC = () => {
    const cardData = [

        {
            id: 1,
            bgColor: "gray.200", // gray-2
            title: (
                <Stack display={{display: "flex", color: "darkPurple.500", flexDirection: "row", alignItems: "baseline"}}>
                    <Typography variant="h4">
                        SWIFT
                    </Typography>
                    <Typography variant="h5" >
                        &amp;
                    </Typography>
                </Stack>
            ),
            subtitle: (
                <Typography variant="h4"color="darkPurple.500">
                    SEPA
                </Typography>
            ),
            icon: (
                <Box component="img" src={swift} sx={{
                  width: {md: "80px", xs: "40px"},
                  height: {md: "80px", xs: "40px"},
                }}/>
            ),
        },

        {

            id: 2,
            bgColor: "lime.100", 
            title: (

                <Typography variant="body4" color="darkPurple.500">
                    AVAILABLE IN
                </Typography>
            ),
            subtitle: (
                <Stack  display={{display: "flex", color: "darkPurple.500", flexDirection: "column",}}>
                    <Stack sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "row",
                    }}>
                    <Typography variant="h4">
                        80
                    </Typography>
                    <Typography variant="h5">
                        +
                    </Typography>
                    </Stack>
                    <Typography variant="body4">
                        COUNTRIES
                    </Typography>
                </Stack>
            ),
            icon: (
                <Box component="img" src={countries} sx={{
                    width: {md: "80px", xs: "40px"},
                    height: {md: "80px", xs: "40px"},
                  }}/>
            ),
        },
        {
            id: 3,
            bgColor: "#F5F5F5", 
            title: (
                <Stack direction="row" alignItems="baseline" color="darkPurple.500">
                    <Typography variant="h4">
                        APM
                    </Typography>
                    <Typography variant="h5" >
                        s
                    </Typography>
                </Stack>
            ),
            subtitle: (
                <Stack direction="row" alignItems="flex-end" color="darkPurple.500">
                    <Typography variant="h4">
                        100
                    </Typography>
                    <Typography variant="h5">
                        +
                    </Typography>
                </Stack>
            ),
            icon: (
                <Box component="img" src={alternative} sx={{
                    width: {md: "80px", xs: "40px"},
                    height: {md: "80px", xs: "40px"},
                  }}/>
            ),
        },
        {
            id: 4,
            bgColor: "#F5F5F5", // gray-2
            title: (
                <Typography variant="body4" color="darkPurple.500">
                    ACCESS TO
                </Typography>
            ),
            subtitle: (
                <Stack>
                    <Stack direction="row" alignItems="flex-end" color="darkPurple.500">
                        <Typography variant="h4">
                            40
                        </Typography>
                        <Typography variant="h5">
                            +
                        </Typography>
                    </Stack>
                    <Typography variant="body4" color="darkPurple.500">
                        CURRENCIES
                    </Typography>
                </Stack>
            ),
            icon: (
                <Box component="img" src={currencies} sx={{
                    width: {md: "80px", xs: "40px"},
                    height: {md: "80px", xs: "40px"},
                  }}/>
            ),
        },

    ];

    return (
        <Box sx={{
            display: "flex",
            maxWidth: "1320px",
            width: "100%",
            margin: "0 auto",
            flexDirection: "column",
            alignItems: { md: "flex-start", xs: "center" },
            justifyContent: "center",
            alignSelf: "stretch",
            padding: { md: "12px", xs: "20px 10px" },
            gap: { md: "32px", xs: "16px" }
        }}>
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: { md: "center", xs: "flex-start" },
                alignSelf: "stretch",
                flexDirection: { md: "row", xs: "column" },
                gap: { md: "0px", xs: "16px" }
            }}>
                <Typography variant='subtitle8' sx={{ alignSelf: "stretch", color: "darkPurple.500" }}>
                    WHY CHOOSE {" "}
                    <Box component="span" sx={{ color: "lightPurple.500" }}>
                        EPAYR
                    </Box>
                    ?
                </Typography>
                <Typography variant="body7" sx={{ color: "gray.300" }}>
                    GLOBAL REACH
                </Typography>
            </Box>
            <Box sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: { md: "8px", xs: "4px" },
                alignSelf: "stretch",
            }}>
                <Grid container spacing={1} justifyContent="center" sx={{width: '100%'}}>
                {cardData.map((card) => (
                <Grid size={{md: 3, xs:6}} key={card.id}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: {md: "126px", xs: "40px"},
                        flex: "1 0 0",
                        borderRadius: "12px",
                        backgroundColor: card.bgColor,
                        padding: {xs: "20px 62.5px 20px 20px", md: "20px 103px 20px 20px"},
                        height: "100%"
                    }}
                >
                    {card.icon}
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: {md: "-10px", xs: "-4px"},
                    }}>
                    {card.title}
                    {card.subtitle}
                    </Box>
                </Box>
                </Grid>

                ))}
                </Grid>

            </Box>

        </Box>
    );
}
export default WhyChoose;